import { useEffect } from "react"
import { useDispatch } from "react-redux"
import {
    startMonitorAsyncOperation,
    stopMonitorAsyncOperation
} from "../Actions/API/Job/JobDownloadActions"
import { DownloadOperation } from "../Reducers/API/Job/JobsDownloadReducer"
import { useAppState } from "./useReduxState"

export function useJobDownloadOperation(
    appID: string,
    id: number | undefined
): DownloadOperation | undefined {
    const dispatch = useDispatch()
    const downloadOperation = useAppState(
        state => state.api.downloadJobs[appID]?.downloadOperation
    )
    const operation = downloadOperation?.operation

    useEffect(() => {
        if (id) {
            dispatch(startMonitorAsyncOperation(appID, id))

            return () => {
                dispatch(stopMonitorAsyncOperation(appID, id))
            }
        }
    }, [appID, dispatch, id])

    useEffect(() => {
        if (operation?.completed)
            dispatch(stopMonitorAsyncOperation(appID, operation.id))
    }, [appID, dispatch, operation?.completed, operation?.id])

    return downloadOperation
}
